module.exports = __webpack_public_path__ + "img/83.c2260f3c.jpg";